/**
 * Thin wrapper around GA4 gtag — safe to call even if gtag hasn't loaded yet.
 * `send_page_view: false` is set in index.html so we control every page_view manually.
 */

const GA_ID = process.env.REACT_APP_GA4_ID;

const isNoTrack = () => {
  try { return !!window.__NOTRACK__; } catch { return false; }
};

/** Fire any GA4 event. No-ops gracefully if gtag isn't available. */
export const gaEvent = (eventName, params = {}) => {
  if (!GA_ID || typeof window.gtag !== 'function' || isNoTrack()) return;
  window.gtag('event', eventName, params);
};

/** Call on every SPA route change. */
export const gaPageView = (path) => {
  if (!GA_ID || typeof window.gtag !== 'function' || isNoTrack()) return;
  window.gtag('config', GA_ID, {
    page_path: path,
    send_page_view: true,
  });
};
